/**
 * @module components/FilmRow
 * @description Film listing row component for the films catalog page.
 * Displays film title, link to detail page, and release date with formatted display.
 */
import React from 'react';
import { Link } from '@/components/Link';
import spacetime from 'spacetime';

/**
 * @typedef Content
 * @property {string|React.ReactNode} title - Film title
 * @property {Object} slug - Slug object with current property
 * @property {string} slug.current - URL-safe film identifier
 * @property {Date|string} releaseDate - Film release date
 * @property {Date|string} [previewDate] - Optional preview date override
 */

/**
 * @typedef Props
 * @property {Content} content - Film metadata object
 */

/**
 * @component FilmRow
 * @type {React.Component<Props>}
 * @summary React class component to display film as row in catalog listing.
 * Shows title with navigation link and formatted release date.
 * @param {Props} props - Component props
 * @returns {React.ReactElement} Clickable row with film info
 */
class FilmRow extends React.Component {
  render() {
    const { title, slug, releaseDate, previewDate } = this.props.content;
    const date = spacetime(releaseDate);
    return (
      <div className="py1 films__row x f jcb aic rel">
        <Link to={`/films/${slug.current}`} className="abs z1 x y top left" />
        <div className="ml05 f jcb aic">
          <h4 className="m0 p0">{title}</h4>
          <svg
            fill="currentColor"
            className="ml1"
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 55 20"
          >
            <polygon
              fillRule="evenodd"
              clipRule="evenodd"
              points="43.3,0 55,10 43.3,20 42.4,19.1 52.2,10.7 0,10.7 0,9.3 52.2,9.3   42.4,0.9 43.3,0 "
            />
          </svg>
        </div>
        <div className="mr05">
          {!previewDate ? (
            <h4 className="small caps m0 p0 akz-e">
              {date.dayName()} {date.monthName()} {date.date()} {date.year()}
            </h4>
          ) : (
            <h4 className="small caps m0 p0 akz-e">{previewDate}</h4>
          )}
        </div>
      </div>
    );
  }
}

export default FilmRow;
